import { MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { useContext } from 'react'

import { EntityListContext } from '../../../Contexts'
import { EntityType } from '../../../Hooks'

const FilterSelect: React.FC = () => {
  const { filter, updateFilter } = useContext(EntityListContext)

  const onFilterChange = (event: SelectChangeEvent<string>) => {
    const selection = event.target.value as EntityType
    updateFilter?.(selection)
  }

  return (
    <Select onChange={onFilterChange} value={filter ?? EntityType.All} variant="standard">
      <MenuItem value={EntityType.All}>Any</MenuItem>
      <MenuItem value={EntityType.Bidder}>Bidder</MenuItem>
      <MenuItem value={EntityType.Owner}>Owner</MenuItem>
      <MenuItem value={EntityType.Player}>Player</MenuItem>
    </Select>
  )
}

export default FilterSelect
